function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useCallback } from 'react';
import { calculateGridClass, calculateItemClass } from './utils/gridLayoutCalculator';
import { filterDisplayableMedia, filterProcessingOrErrorMedia } from './utils/mediaFilter';
/**
 * 미디어 프리뷰 커스텀 훅
 * 미디어 그리드 레이아웃과 상호작용 상태 관리
 */ export default function useMediaPreview(param) {
    var media = param.media, onRemove = param.onRemove, _param_isSubmitting = param.isSubmitting, isSubmitting = _param_isSubmitting === void 0 ? false : _param_isSubmitting;
    // 상태 관리
    var _useState = _sliced_to_array(useState(null), 2), hoveredIndex = _useState[0], setHoveredIndex = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isModalOpen = _useState1[0], setIsModalOpen = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), activeModalIndex = _useState2[0], setActiveModalIndex = _useState2[1];
    // 처리 상태가 정상인 미디어만 표시
    var displayableMedia = filterDisplayableMedia(media);
    // 처리 중이거나 오류 상태인 미디어
    var processingMedia = filterProcessingOrErrorMedia(media);
    var hasProcessingMedia = processingMedia.length > 0;
    // 그리드 레이아웃 클래스 결정 래퍼 함수
    var getGridClass = useCallback(function() {
        return calculateGridClass(displayableMedia);
    }, [
        displayableMedia
    ]);
    // 미디어 아이템 클래스 계산 래퍼 함수
    var getItemClass = useCallback(function(item, index) {
        return calculateItemClass(item, index, displayableMedia);
    }, [
        displayableMedia
    ]);
    // 미디어 항목 클릭 핸들러
    var handleMediaClick = useCallback(function(item, index) {
        setIsModalOpen(true);
        setActiveModalIndex(index);
    }, []);
    // 모달 닫기 핸들러
    var handleCloseModal = useCallback(function(e) {
        e.stopPropagation();
        setIsModalOpen(false);
    }, []);
    // 다음 이미지로 이동 핸들러
    var handleNextImage = useCallback(function(e) {
        e.stopPropagation();
        setActiveModalIndex(function(prev) {
            return prev === displayableMedia.length - 1 ? 0 : prev + 1;
        });
    }, [
        displayableMedia.length
    ]);
    // 이전 이미지로 이동 핸들러
    var handlePrevImage = useCallback(function(e) {
        e.stopPropagation();
        setActiveModalIndex(function(prev) {
            return prev === 0 ? displayableMedia.length - 1 : prev - 1;
        });
    }, [
        displayableMedia.length
    ]);
    return {
        hoveredIndex: hoveredIndex,
        setHoveredIndex: setHoveredIndex,
        isModalOpen: isModalOpen,
        activeModalIndex: activeModalIndex,
        setActiveModalIndex: setActiveModalIndex,
        displayableMedia: displayableMedia,
        getGridClass: getGridClass,
        getItemClass: getItemClass,
        handleMediaClick: handleMediaClick,
        handleCloseModal: handleCloseModal,
        handleNextImage: handleNextImage,
        handlePrevImage: handlePrevImage,
        hasProcessingMedia: hasProcessingMedia,
        processingMedia: processingMedia
    };
}
